(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/draw.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/draw.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.models = svs.matchen.models || {};

  svs.matchen.models.Draw = Backbone.Model.extend({
    url: function() {
      var drawNumber = this.get('drawNumber');

      if (!drawNumber) {
        this.logger.warn('Invalid drawNumber.', drawNumber);
      }

      return svs.core.jupiter.url() + '/draw/1/matchen/draws/' + drawNumber;
    },

    constructor: function() {
      this.logger = new svs.core.log.Logger('svs.matchen.models.Draw');

      Backbone.Model.prototype.constructor.apply(this, arguments);
    },

    parse: function(attrs) {
      if (!attrs) {
        this.logger.info('Invalid attributes.', attrs);
        return {};
      }

      if (attrs && attrs.error) {
        this.logger.info('Error.', attrs.error);
        return {};
      }

      if (attrs && attrs.draw) {
        attrs = attrs.draw;
      }

      svs.matchen.app.config.setSport(attrs.sport.type);

      this.parseMatch(attrs);
      this.parseGoalAvgTrend(attrs);
      this.parseOutcomes(attrs);

      return attrs;
    },

    parseMatch: function(attrs) {
      var match =
        attrs.events && attrs.events.length === 1 ?
          attrs.events[0].match :
          null;

      if (!match) {
        attrs.hideDraw = true;
      } else {
        _.extend(attrs, attrs.events[0]);
        attrs.sportIfCoverage = attrs.sport;
      }
    },

    parseGoalAvgTrend: function(attrs) {
      var goalAverageTrend = {
        home: {
          trend: 0,
          goalAverage: '-'
        },
        away: {
          trend: 0,
          goalAverage: '-'
        }
      };

      if (!attrs.goalAverageTrend) {
        if (
          attrs &&
          attrs.match &&
          attrs.match.participants &&
          attrs.match.participants.length &&
          attrs.match.participants[0]
        ) {
          goalAverageTrend.home.trend = attrs.match.participants[0].trend;
          delete attrs.match.participants[0].trend;
        }

        if (
          attrs &&
          attrs.match &&
          attrs.match.participants &&
          attrs.match.participants.length &&
          attrs.match.participants[1]
        ) {
          goalAverageTrend.away.trend = attrs.match.participants[1].trend;
          delete attrs.match.participants[1].trend;
        }

        if (
          attrs &&
          attrs.match &&
          attrs.match.participants &&
          attrs.match.participants.length &&
          attrs.match.participants[0]
        ) {
          goalAverageTrend.home.goalAverage =
            attrs.match.participants[0].goalAvg;
          delete attrs.match.participants[0].goalAvg;
        }

        if (
          attrs &&
          attrs.match &&
          attrs.match.participants &&
          attrs.match.participants.length &&
          attrs.match.participants[1]
        ) {
          goalAverageTrend.away.goalAverage =
            attrs.match.participants[1].goalAvg;
          delete attrs.match.participants[1].goalAvg;
        }

        attrs.goalAverageTrend = goalAverageTrend;
      }

      return attrs;
    },

    parseOutcomes: function(attrs) {
      var homeOutcomes;
      var awayOutcomes;
      var svenskaFolket = {
        home: [],
        away: []
      };
      var min = svs.matchen.app.config.getMinOutcomeValue();
      var max = svs.matchen.app.config.getMaxOutcomeValue();
      var maxHomePercent = 0;
      var maxAwayPercent = 0;

      if (
        !(
          attrs &&
          attrs.events &&
          attrs.events.length &&
          attrs.events[0] &&
          attrs.events[0].svenskaFolket
        )
      ) {
        svenskaFolket = this.getDefaultOutcomes();
      } else {
        svenskaFolket = _.reduce(
          attrs.events[0].svenskaFolket,
          function(memo, obj) {
            var away;
            var awayPercent;
            var home;
            var homePercent;
            var outcomes;

            try {
              outcomes = obj.score.split('-');
              home = parseInt(outcomes[0], 10);
              away = parseInt(outcomes[1], 10);
              homePercent = parseInt(obj.home, 10);
              awayPercent = parseInt(obj.away, 10);
            } catch (e) {
              this.logger.error(
                'Error when using parseInt() on outcomes',
                e,
                outcomes[0],
                outcomes[1]
              );
            }

            maxHomePercent =
              homePercent > maxHomePercent ? homePercent : maxHomePercent;
            maxAwayPercent =
              awayPercent > maxAwayPercent ? awayPercent : maxAwayPercent;

            if (home >= min && home <= max) {
              memo.home.push({
                team: 'h',
                percent: obj.home,
                outcome: outcomes[0],
                selected: false,
                hidden: false
              });
            }

            if (away >= min && away <= max) {
              memo.away.push({
                team: 'a',
                percent: obj.away,
                outcome: outcomes[1],
                selected: false,
                hidden: false
              });
            }

            return memo;
          },
          svenskaFolket
        );
      }

      homeOutcomes = new svs.matchen.collections.Outcomes(svenskaFolket.home);
      homeOutcomes.setHeatmapValues();
      homeOutcomes.setMaxPercent(maxHomePercent);

      awayOutcomes = new svs.matchen.collections.Outcomes(svenskaFolket.away);
      awayOutcomes.setHeatmapValues();
      awayOutcomes.setMaxPercent(maxAwayPercent);

      this.set({
        homeOutcomes: homeOutcomes,
        awayOutcomes: awayOutcomes
      });

      this.listenTo(
        this.get('homeOutcomes'),
        'change',
        this.handleOutcomeUpdate
      );
      this.listenTo(
        this.get('awayOutcomes'),
        'change',
        this.handleOutcomeUpdate
      );
    },

    handleOutcomeUpdate: function(model) {
      if (model && model.changed && _.has(model.changed, 'selected')) {
        this.trigger('outcomeChange');
      }
    },

    getHomeOutcomes: function() {
      return this.get('homeOutcomes');
    },

    getAwayOutcomes: function() {
      return this.get('awayOutcomes');
    },

    getSportId: function() {
      return this.get('sport') && this.get('sport').id;
    },

    getMatchId: function() {
      return this.get('match') && this.get('match').matchId;
    },

    getLeagueId: function() {
      return (
        this.get('match') &&
        this.get('match').league &&
        this.get('match').league.id
      );
    },

    getCountryISOCode: function() {
      return (
        this.get('match') &&
        this.get('match').league &&
        this.get('match').league.country &&
        this.get('match').league.country.isoCode
      );
    },

    getDefaultOutcomes: function() {
      var outcomes = {
        home: [],
        away: []
      };
      var minOutcomeValue = svs.matchen.app.config.getMinOutcomeValue();
      var maxOutcomeValue = svs.matchen.app.config.getMaxOutcomeValue();

      for (var i = minOutcomeValue; i <= maxOutcomeValue; i++) {
        var homeOutcome = {
          team: 'h',
          outcome: i,
          percent: 0,
          selected: false,
          hidden: false
        };
        var awayOutcome = _.clone(homeOutcome);

        awayOutcome.team = 'a';

        outcomes.home.push(homeOutcome);
        outcomes.away.push(awayOutcome);
      }

      return outcomes;
    },

    deselectOutcomes: function() {
      this.getHomeOutcomes().deselectAll();
      this.getAwayOutcomes().deselectAll();
    },

    hasHeatmapExpandDown: function() {
      return this.getHomeOutcomes().hasHeatmapExpandDown;
    },

    hasHeatmapExpandUp: function() {
      return this.getHomeOutcomes().hasHeatmapExpandUp;
    },

    hasSelectedOutcomes: function() {
      return (
        this.getHomeOutcomes().isAnySelected() ||
        this.getAwayOutcomes().isAnySelected()
      );
    },

    supportsXperten: function() {
      return (
        this.get('sport').type == svs.components.sport.sportTypes.SportTypes.Soccer ||
        this.get('sport').type == svs.components.sport.sportTypes.SportTypes.Hockey
      );
    },

    getRollOverIn: function() {
      var rollOverIn;

      if (
        svs.utils.ns.isNamespace('attributes.fund.rolloverIn', this) &&
        this.get('fund').rolloverIn !== '0,00'
      ) {
        rollOverIn = this.get('fund').rolloverIn;
      }

      return rollOverIn;
    },

    getLeagueName: function() {
      var league = '';

      if (
        this.get('match') &&
        this.get('match').league &&
        this.get('match').league.name
      ) {
        league = this.get('match').league.name;
      }

      return league;
    },

    getHomeTeamName: function() {
      var name = '';

      if (
        this.get('match') &&
        this.get('match').participants &&
        this.get('match').participants.length &&
        this.get('match').participants[0] &&
        this.get('match').participants[0].name
      ) {
        name = this.get('match').participants[0].name;
      }

      return name;
    },

    getAwayTeamName: function() {
      var name = '';

      if (
        this.get('match') &&
        this.get('match').participants &&
        this.get('match').participants.length &&
        this.get('match').participants[1] &&
        this.get('match').participants[1].name
      ) {
        name = this.get('match').participants[1].name;
      }

      return name;
    },

    getComment: function() {
      var comment = '';

      if (
        this.get('events') &&
        this.get('events').length &&
        this.get('events')[0] &&
        this.get('events')[0].comment
      ) {
        comment = this.get('events')[0].comment;
      }

      return comment;
    },

    getExtraMoney: function() {
      var extraMoney;

      if (
        svs.utils.ns.isNamespace('attributes.fund.extraMoney', this) &&
        this.get('fund').extraMoney !== '0,00'
      ) {
        extraMoney = this.get('fund').extraMoney;
      }

      return extraMoney;
    }
  });
})(Backbone, _, svs);


 })(window);